import React from 'react';
import { ButtonPropTypes } from './button.props';
import { StyledButton, Text } from './Button.styles';

const Button = ({
  onClick,
  text,
  color = '#fff',
  bgColor,
  width,
  height,
  borderRadius = '5px',
  padding = '12px',
  fontSize = '13px',
  border = 'none',
  renderIcon,
  iconAfter = false,
  style,
  children,
  margin,
  textMargin = '0px 6px 0px 0px',
  ...props
}: ButtonPropTypes) => (
  <>
    <StyledButton
      color={color}
      padding={padding}
      border={border}
      bgColor={bgColor}
      width={width}
      height={height}
      onClick={onClick}
      borderRadius={borderRadius}
      style={style}
      margin={margin}
      {...props}
    >
      {renderIcon && !iconAfter ? renderIcon() : null}
      <Text fontSize={fontSize} textMargin={textMargin}>{text}</Text>
      {renderIcon && iconAfter ? renderIcon() : null}
      {children}
    </StyledButton>
  </>
);

export default Button;
